import { api } from './client'
import { withCustomerIds } from './params'

export function fetchAIStatus() {
  return api.get('/ai/status').then((r) => r.data)
}

export function fetchAISettings() {
  return api.get('/ai/settings').then((r) => r.data)
}

export function fetchAIOptions() {
  return api.get('/ai/options').then((r) => r.data)
}

export function updateAISettings(body) {
  return api.put('/ai/settings', body).then((r) => r.data)
}

export function queryAI(body, customerIds = []) {
  return api
    .post('/ai/query', withCustomerIds(body, customerIds), { timeout: 120000 })
    .then((r) => r.data)
}
